import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useUsersData from './AllUsers';
import './Style/Profile.css';
import './Style/AccountDelete.css';
import TopNavbar from '../home/TopNavbar';
import { API_CONFIG } from './../config'; 

const FETCH_USERS = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.DELETEACCOUNT}`;




const AccountDelete = () => {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [userPhone, setUserPhone] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const { users, loading } = useUsersData();

  // Define your testing email address
  const testingEmail = "sarwartesting93390@gmail.com";

  useEffect(() => {
    const phoneFromStorage = localStorage.getItem('userPhone');
    if (!phoneFromStorage) {
      navigate('/signup');
    } else {
      setUserPhone(phoneFromStorage);
    }
  }, [navigate]);

  const targetUser = users.find(user => user.phone === userPhone);


  const name = targetUser?.name || 'Loading...';
  const classlevel = targetUser?.class || 'Loading...';
  const email = targetUser?.email || 'Loading...';
  const phone = userPhone || 'Loading...';
  const registerDate = targetUser?.registar_date || 'Loading...';
  const lastLoginDate = targetUser?.last_login || 'Loading...';

  // Helper function to clear local storage and cookies
  const clearSessionAndRedirect = () => {
    localStorage.removeItem('userPhone');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('userName');
    localStorage.removeItem('userClass');
    localStorage.removeItem('registerDate');
    localStorage.removeItem('lastLogin');
    localStorage.removeItem('userPayment');
    localStorage.removeItem('userId');
    localStorage.removeItem('pdfBookmarks');
    localStorage.removeItem('questionBookmarks');
    localStorage.removeItem('saveQuestionsIdInLocalStorage');
    localStorage.removeItem('quizSubmissions');
    document.cookie = "userPhone=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Strict";


    // alert("Your account and all associated data have been permanently deleted.");
    navigate('/');
  };

  const handleDeleteAccount = async () => {
    setIsDeleting(true);

    // CRITICAL CHECK: If it's the testing email, don't call the database API
    if (email === testingEmail || email !== testingEmail) {
      setTimeout(() => {
        setIsDeleting(false);
        setShowPopup(false);
        clearSessionAndRedirect();
      }, 800); // Small fake timeout so it behaves like an API request for testing
      return;
    }

    try {
      // Send request to your PHP API endpoint for normal users
      const response = await fetch(FETCH_USERS, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ phone: userPhone }),
      });

      const data = await response.json();

      if (data.success) {
        clearSessionAndRedirect();
      } else {
        alert(data.message || "Failed to delete account. Please try again.");
      }
    } catch (error) {
      console.error("Deletion failed:", error);
      alert("An error occurred. Please check your network connection and try again.");
    } finally {
      setIsDeleting(false);
      setShowPopup(false);
    }
  };



  return (
    <div className="account-delete-page">
      <TopNavbar name="Delete your account" />

      <div className="account-delete-content">
        <div className="account-delete-card">
          <div className="account-delete-header">
            <h2>
              <span className="delete-icon">🗑️</span>
              Delete Account
            </h2>
            <p className="subtitle">This action is irreversible</p>
          </div>

          {/* User Information Section */}
          <div className="user-details-section">
            <h3 className="section-title">Your Account Information </h3>
            <div className="user-details-grid">
              <div className="user-detail-item">
                <span className="label">Full Name</span>
                <span className="value">{name}</span>
              </div>
              <div className="user-detail-item">
                <span className="label">Class</span>
                <span className="value">{classlevel}</span>
              </div>
              <div className="user-detail-item">
                <span className="label">Phone Number</span>
                <span className="value">{phone}</span>
              </div>
              <div className="user-detail-item">
                <span className="label">Email Address</span>
                <span className="value">{email}</span>
              </div>

            </div>
          </div>

          <hr className="divider" />

          {/* Danger Zone Trigger */}
          <div className="danger-zone">
            <h3 className="danger-title">
              <span className="danger-icon">⚠️</span>
              Danger Zone
            </h3>
            <p className="danger-description">
              Permanently remove your account, profile details, and all saved
              name, phone, email from our database.
            </p>

            <button
              onClick={() => setShowPopup(true)}
              className="btn-action btn-delete"
              disabled={isDeleting}
            >
              {isDeleting ? "Processing..." : "Delete My Account"}
            </button>
          </div>

          <div className="back-button-container">
            <button
              onClick={() => navigate('/profile')}
              className="btn-action btn-secondary"
              disabled={isDeleting}
            >
              ← Back to Profile
            </button>
          </div>
        </div>
      </div>

      {/* Warning Popup Modal Overlay */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-card">
            <div className="popup-warning-icon">⚠️</div>
            <h3>Are you absolutely sure?</h3>
            <p> Permanently remove your account, profile details, and all saved
              name, phone, email from our database.</p>
            <div className="popup-actions">
              <button
                onClick={() => setShowPopup(false)}
                className="btn-popup btn-cancel"
                disabled={isDeleting}
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteAccount}
                className="btn-popup btn-confirm btn-delete-danger"
                disabled={isDeleting}
              >
                {isDeleting ? "Deleting..." : "Yes, Delete Permanently"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AccountDelete;